// src/common/query/StreetViewCanvas.jsx
import React, { useEffect, useRef, useState } from "react";
import { Loader } from "@googlemaps/js-api-loader";

export default function StreetView({ address, height = 460, radius = 60 }) {
  const mapRef = useRef(null);
  const panoRef = useRef(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    let canceled = false;
    let pano = null;
    let map = null;

    (async () => {
      try {
        if (!address) return;
        setErr("");

        const loader = new Loader({
          apiKey: "AIzaSyDNZ5JW-VEniKiFdSoySNFQdyhuaOu9YIc",
          version: "weekly",
          language: "pt-BR",
          region: "BR",
        });
        await loader.load();
        if (canceled) return;

        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ address: address.trim() }, (results, status) => {
          if (canceled) return;
          if (status !== "OK" || !results?.length) {
            setErr("Endereço não encontrado.");
            return;
          }

          const loc = results[0].geometry?.location;
          if (!loc) {
            setErr("Sem coordenadas para o endereço.");
            return;
          }

          // ===== MAPA COM PIN =====
          if (mapRef.current) {
            map = new window.google.maps.Map(mapRef.current, {
              center: loc,
              zoom: 17,
              streetViewControl: false,
              mapTypeControl: false,
              fullscreenControl: false,
            });

            new window.google.maps.Marker({
              position: loc,
              map,
            });
          }

          // ===== STREET VIEW =====
          const svs = new window.google.maps.StreetViewService();
          svs.getPanorama({ location: loc, radius }, (data, svStatus) => {
            if (canceled) return;
            if (svStatus === "OK" && data?.location?.latLng) {
              if (panoRef.current) {
                pano = new window.google.maps.StreetViewPanorama(
                  panoRef.current,
                  {
                    position: data.location.latLng,
                    pov: { heading: 0, pitch: 0 },
                    zoom: 1,
                    addressControl: false,
                    fullscreenControl: false,
                    linksControl: true,
                    panControl: true,
                    motionTracking: false,
                  }
                );
              }
            } else {
              setErr("Não há cobertura de Street View neste endereço.");
            }
          });
        });
      } catch (e) {
        console.error(e);
        setErr("Falha ao carregar o Google Maps.");
      }
    })();

    return () => {
      canceled = true;
      if (mapRef.current) mapRef.current.innerHTML = "";
      if (panoRef.current) panoRef.current.innerHTML = "";
      map = null;
      pano = null;
    };
  }, [address, radius]);

  return (
    <div
      style={{ height }}
      className="w-full rounded-xl overflow-hidden border border-gray-200 bg-gray-50"
    >
      {err ? (
        <div className="p-3 text-sm text-gray-600">{err}</div>
      ) : (
        <div className="w-full h-full flex flex-col gap-2">
          {/* Mapa com PIN */}
          <div
            ref={mapRef}
            style={{ width: "100%", height: "35%" }}
            className="border-b border-gray-200"
          />

          {/* Street View */}
          <div ref={panoRef} style={{ width: "100%", height: "65%" }} />
        </div>
      )}
    </div>
  );
}
